import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import Fab from '@material-ui/core/Fab';
import Badge from '@material-ui/core/Badge';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import PersonIcon from '@material-ui/icons/Person';
import ja from "date-fns/locale/ja";
import './Css/Grid.css';
import DateFnsUtils from '@date-io/date-fns';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import KyDetails from '../KyDetail/Index';
import * as CashTeller from './Saga/CashTellers';

// import * as MonthlyMoney from './Saga/MonthlyMoney';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
var moment = require('moment-timezone');

var selctedDate = new Date();

var SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
};



function reverseSortDirection(sortDir) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}

class SortHeaderCell extends React.Component {
  constructor(props) {
    super(props);

    this._onSortChange = this._onSortChange.bind(this);

  }

  render() {
    var { onSortChange, sortDir, children, ...props } = this.props;
    return (
      <Cell {...props} onClick={this._onSortChange}>
        {children} {sortDir ? (sortDir === SortTypes.DESC ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />) : ''}
      </Cell>
    );
  }

  _onSortChange(e) {

    e.preventDefault();

    if (this.props.onSortChange) {
      this.props.onSortChange(
        this.props.columnKey,
        this.props.sortDir ?
          reverseSortDirection(this.props.sortDir) :
          SortTypes.DESC
      );
    }
  }
}

var money = 0;
var payin = 0;
var payout = 0;
const columns = [
  { key: 'No', name: 'No', width: 30 },
  { key: 'transction_date', name: '取引日', width: 80 },
  { key: 'nickname', name: '担当', width: 80 },
  { key: 'name', name: '内容', width: 200 },
  { key: 'transction_name', name: '名称', width: 200 },
  { key: 'room_name', name: '区画･号', width: 70 },
  { key: 'customer_name', name: '顧客名', width: 100 },
  { key: 'remarks', name: '備考', width: 200 },
  { key: 'payment_in', name: '入', width: 80 },
  { key: 'payment_out', name: '出', width: 80 },
  { key: 'payment_result', name: '残額', width: 80 },
  { key: 'payer', name: '確認者', width: 70 },
  { key: 'keiri', name: '経理', width: 220 },
  { key: 'delete', name: '', width: 70 },
]

const keiri_columns = [
  { key: 'No', name: 'No', width: 30 },
  { key: 'created_at', name: '登録日', width: 80 },
  { key: 'transction_date', name: '取引日', width: 80 },
  { key: 'kamoku_name', name: '科目', width: 120 },
  { key: 'Tenpo_Name_Short', name: '部署', width: 115 },
  { key: 'nickname', name: '担当', width: 80 },
  { key: 'name', name: '内容', width: 200 },
  { key: 'transction_name', name: '名称', width: 200 },
  { key: 'room_name', name: '区画･号', width: 70 },
  { key: 'customer_name', name: '顧客名', width: 100 },
  { key: 'remarks', name: '備考', width: 200 },
  { key: 'payment_in', name: '入', width: 80 },
  { key: 'payment_out', name: '出', width: 80 },
  { key: 'payment_result', name: '残額', width: 80 },
  { key: 'payer', name: '支払者', width: 70 },
  { key: 'keiri', name: '経理', width: 220 },
  { key: 'delete', name: '', width: 70 },
]

const keiri_columns2 = [
  { key: 'No', name: 'No', width: 30 },
  { key: 'transction_date', name: '取引日', width: 80 },
  { key: 'Tenpo_Name_Short', name: '部署', width: 115 },
  { key: 'nickname', name: '担当', width: 80 },
  { key: 'name', name: '内容', width: 200 },
  { key: 'transction_name', name: '名称', width: 200 },
  { key: 'room_name', name: '区画･号', width: 70 },
  { key: 'customer_name', name: '顧客名', width: 100 },
  { key: 'remarks', name: '備考', width: 200 },
  { key: 'payment_in', name: '入', width: 80 },
  { key: 'payment_out', name: '出', width: 80 },
  { key: 'payment_result', name: '残額', width: 80 },
  { key: 'payer', name: '支払者', width: 70 },
  { key: 'keiri', name: '経理', width: 220 },
  { key: 'delete', name: '', width: 70 },
]


function deletes(id, props) {
  // alert(id);
  var result = window.confirm('選択した行を削除します。データは戻りません。宜しいですか？');
  if (result) {
    var data = { id: id }
    props.cash_tellers_delete(data);
    alert("削除されました")
    props.GetList();

  }
}

function payer_check(id, props, e) {

  if (e.target.checked !== true) {

    alert("チェックは消せません")
    props.GetList();
    return;
  }

  var data = {
    id: id,
    section_check_user: props.user_details.id
  }
  props.cash_tellers_update(data);
  props.GetList();

}

function keiri_check(id, props, e) {

  if (e.target.checked !== true) {

    alert("チェックは消せません")
    props.GetList();
    return;
  }

  var data = {
    id: id,
    keiri_check_user: props.user_details.id
  }
  props.cash_tellers_update(data);
  props.GetList();


}


function keiri_check_out(id, props, e) {
  var data = {
    id: id,
    keiri_check_user: null,
  }
  props.cash_tellers_update(data);
  alert("チェックを取り消しました");
  props.GetList();

}


const TrDate = ({ column, props, rowIndex }) =>
  (() => {

    // moment(new Date()).tz("Asia/Tokyo").format('YYYY-MM-DD HH:mm:ss');
    // 曜日を取る
    var datess = new Date(props[rowIndex][column.key]);
    var dayOfWeek = datess.getDay();
    var dayOfWeekStr = ["日", "月", "火", "水", "木", "金", "土"][dayOfWeek];

    // var date = moment(props[rowIndex][column.key], 'YYYY-MM-DD HH:mm:ss').tz("Asia/Tokyo").format('YYYY-MM-DD HH:mm:ss');
    var date = moment(props[rowIndex][column.key], 'YYYY-MM-DD HH:mm:ss').tz("Asia/Tokyo").format('DD日(' + dayOfWeekStr + ')');
    return <Cell style={{ whiteSpace: "nowrap", fontSize: "17px" }}>{date}</Cell>
  })()

const Delete = ({ column, props, rowIndex }) =>
  (() => {
    if (props.section == 10 || props.section == 8 || props.section == 30 || props.section == 32) {
      return <Cell>
        <button className="btn btn-sm btn-danger"
          onClick={() => deletes(props.cash_tellers_list[rowIndex]["id"], props)}>
          ×
      </button>
      </Cell>;
    } else if (props.cash_teller_nowmonthly[0] || props.cash_tellers_list[rowIndex]["keiri_check_user"]) {
      return "";
    } else {
      return <Cell>
        <button className="btn btn-sm btn-danger"
          onClick={() => deletes(props.cash_tellers_list[rowIndex]["id"], props)}>
          ×
      </button>
      </Cell>;
    }
  })()

const Payer = ({ column, props, rowIndex }) =>
  (() => {
    if (props.cash_tellers_list[rowIndex]["section_check_user"]) {
      return <Cell style={{ fontSize: "18px" }} >
        ✅
      </Cell>;
    } else {
      return <Cell style={{ fontSize: "18px" }} >
        <FormControlLabel
          onChange={(e) => payer_check(props.cash_tellers_list[rowIndex]["id"], props, e)}
          id={props.cash_tellers_list[rowIndex]["id"]}
          style={{ paddingInline: "10px" }}
          control={<Checkbox name="Payer" />}
          label=""
        />
      </Cell>;
    }
  })()

const Keiri = ({ column, props, rowIndex }) =>
  (() => {
    if (props.cash_tellers_list[rowIndex]["keiri_check_user"]) {
      return <Cell style={{ fontSize: "18px" }} >
        <span onClick={(e) => keiri_check_out(props.cash_tellers_list[rowIndex]["id"], props, e)}>✅</span>
        {moment(props.cash_tellers_list[rowIndex]["keiri_check_at"], 'YYYY-MM-DD HH:mm:ss').tz("Asia/Tokyo").format('YYYY-MM-DD hh:mm:ss')}
      </Cell>;
    } else if (props.section == 10 || props.section == 8 || props.section == 30 || props.section == 32) {
      if (props.cash_tellers_list[rowIndex]["section_check_user"]) {
        return <Cell style={{ fontSize: "18px" }} >
          <FormControlLabel
            onChange={(e) => keiri_check(props.cash_tellers_list[rowIndex]["id"], props, e)}
            style={{ paddingInline: "10px" }}
            control={<Checkbox name="Payer" />}
            label=""
          />
        </Cell>;
      } else {
        return "店舗チェック待ち";
      }
    } else {
      return "";
    }
  })()

const InOut = ({ column, props, rowIndex }) =>
  (() => {

    if (column.key == "payment_in" && props.cash_tellers_list[rowIndex]["payment"] > 0) {
      var dispmoney = props.cash_tellers_list[rowIndex]["payment"].toLocaleString();
      if (rowIndex == 0) {
        payin = 0;
      }
      payin = payin + props.cash_tellers_list[rowIndex]["payment"];
      props.In(payin);
      return <Cell style={{ marginLeft: "auto", whiteSpace: "nowrap", fontSize: "18px" }} >
        {dispmoney}
      </Cell>;
    } else if (column.key == "payment_out" && props.cash_tellers_list[rowIndex]["payment"] < 0) {
      var outmoney = props.cash_tellers_list[rowIndex]["payment"] - props.cash_tellers_list[rowIndex]["payment"] - props.cash_tellers_list[rowIndex]["payment"];
      var dispmoney = outmoney.toLocaleString();
      props.Out(props.cash_tellers_list[rowIndex]["payment"]);
      return <Cell style={{ marginLeft: "auto", whiteSpace: "nowrap", fontSize: "18px" }} >
        {dispmoney}
      </Cell>;
    } else {
      return ""
    }
  })()



const Total = ({ column, props, rowIndex }) =>
  (() => {
    if (props.cash_teller_monthly[0]) {
      money = props.cash_tellers_list[rowIndex]["payment_result"] + props.cash_teller_monthly[0].payment_result;
      var dispmoney = money.toLocaleString();
      return <Cell style={{ marginLeft: "auto", whiteSpace: "nowrap", fontSize: "18px" }} >
        {dispmoney}
      </Cell>;
    } else {
      return "";
    }
  })()



const No = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap", fontSize: "18px" }} >{rowIndex + 1}</Cell>;


const Base = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap", fontSize: "18px" }} >{props[rowIndex][column.key]}</Cell>;



class CashList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: columns,
      keiri_columns: keiri_columns,
      keiri_columns2: keiri_columns2,
      reflash: false,
      colSortDirs: {},
    };
    this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);
  }
  _onColumnResizeEndCallback(newColumnWidth, columnKey) {
    let columnsset = this.state.columns.map(function (value) {
      if (value.key === columnKey) {
        value.width = newColumnWidth
      }
      return value
    })
    this.setState({ columns: columnsset })

    let keiri_columnsset = this.state.keiri_columns.map(function (value) {
      if (value.key === columnKey) {
        value.width = newColumnWidth
      }
      return value
    })
    this.setState({ keiri_columns: keiri_columnsset })

    let keiri_columnsset2 = this.state.keiri_columns2.map(function (value) {
      if (value.key === columnKey) {
        value.width = newColumnWidth
      }
      return value
    })
    this.setState({ keiri_columns2: keiri_columnsset2 })
  }



  render() {

    if (this.props.SelectSection == 102) {
      // if (this.props.section == 10 || this.props.section == 8 || this.props.section == 30) {
      return (
        <div id="seisanlist">
          <Table
            rowHeight={45}
            rowsCount={this.props.cash_tellers_list.length}
            onColumnResizeEndCallback={this._onColumnResizeEndCallback}
            width={window.innerWidth - 110}
            height={window.innerHeight - 400}
            headerHeight={40}>
            {keiri_columns.map(function (value, i) {
              return <Column
                columnKey={value.key}
                header={<SortHeaderCell
                  onSortChange={this._onSortChange}
                  sortDir={this.state.colSortDirs[value.key]}
                  style={{ whiteSpace: "nowrap" }}>{value.name}</SortHeaderCell>}

                // cell={({ rowIndex, ...props }) => (<Cell style={{ whiteSpace: "nowrap" }} >{this.props.seisan_follow_list[rowIndex][value.key]}</Cell>)}
                cell={({ rowIndex, ...props }) => (
                  value.key === "transction_date" || value.key === "created_at" ? <TrDate column={value} props={this.props.cash_tellers_list} rowIndex={rowIndex}></TrDate>
                    : value.key === "delete" ? <Delete column={value} props={this.props} rowIndex={rowIndex}></Delete>
                      : value.key === "payment_out" ? <InOut column={value} props={this.props} rowIndex={rowIndex}></InOut>
                        : value.key === "payment_in" ? <InOut column={value} props={this.props} rowIndex={rowIndex}></InOut>
                          : value.key === "keiri" ? <Keiri column={value} props={this.props} rowIndex={rowIndex}></Keiri>
                            : value.key === "payer" ? <Payer column={value} props={this.props} rowIndex={rowIndex}></Payer>
                              : value.key === "payment_result" ? <Total column={value} props={this.props} rowIndex={rowIndex}></Total>
                                : value.key === "No" ? <No column={value} props={this.props.cash_tellers_list} rowIndex={rowIndex}></No>
                                  : <Base column={value} props={this.props.cash_tellers_list} rowIndex={rowIndex}></Base>
                )}
                width={this.state.keiri_columns.filter(a => a.key === value.key)[0].width}
                isResizable={true}
                fixed={value.frozen}
              />
            }, this)}
          </Table >
        </div>
      );
    } else if (this.props.SelectSection == 101) {
      // if (this.props.section == 10 || this.props.section == 8 || this.props.section == 30) {
      return (
        <div id="seisanlist">
          <Table
            rowHeight={45}
            rowsCount={this.props.cash_tellers_list.length}
            onColumnResizeEndCallback={this._onColumnResizeEndCallback}
            width={window.innerWidth - 110}
            height={window.innerHeight - 400}
            headerHeight={40}>
            {keiri_columns2.map(function (value, i) {
              return <Column
                columnKey={value.key}
                header={<SortHeaderCell
                  onSortChange={this._onSortChange}
                  sortDir={this.state.colSortDirs[value.key]}
                  style={{ whiteSpace: "nowrap" }}>{value.name}</SortHeaderCell>}

                // cell={({ rowIndex, ...props }) => (<Cell style={{ whiteSpace: "nowrap" }} >{this.props.seisan_follow_list[rowIndex][value.key]}</Cell>)}
                cell={({ rowIndex, ...props }) => (
                  value.key === "transction_date" || value.key === "created_at" ? <TrDate column={value} props={this.props.cash_tellers_list} rowIndex={rowIndex}></TrDate>
                    : value.key === "delete" ? <Delete column={value} props={this.props} rowIndex={rowIndex}></Delete>
                      : value.key === "payment_out" ? <InOut column={value} props={this.props} rowIndex={rowIndex}></InOut>
                        : value.key === "payment_in" ? <InOut column={value} props={this.props} rowIndex={rowIndex}></InOut>
                          : value.key === "keiri" ? <Keiri column={value} props={this.props} rowIndex={rowIndex}></Keiri>
                            : value.key === "payer" ? <Payer column={value} props={this.props} rowIndex={rowIndex}></Payer>
                              : value.key === "payment_result" ? <Total column={value} props={this.props} rowIndex={rowIndex}></Total>
                                : value.key === "No" ? <No column={value} props={this.props.cash_tellers_list} rowIndex={rowIndex}></No>
                                  : <Base column={value} props={this.props.cash_tellers_list} rowIndex={rowIndex}></Base>
                )}
                width={this.state.keiri_columns2.filter(a => a.key === value.key)[0].width}
                isResizable={true}
                fixed={value.frozen}
              />
            }, this)}
          </Table >
        </div>
      );
    } else {
      return (
        <div id="seisanlist">
          <Table
            rowHeight={45}
            rowsCount={this.props.cash_tellers_list.length}
            onColumnResizeEndCallback={this._onColumnResizeEndCallback}
            width={window.innerWidth - 110}
            height={window.innerHeight - 400}
            headerHeight={40}>
            {columns.map(function (value, i) {
              return <Column
                columnKey={value.key}
                header={<SortHeaderCell
                  onSortChange={this._onSortChange}
                  sortDir={this.state.colSortDirs[value.key]}
                  style={{ whiteSpace: "nowrap" }}>{value.name}</SortHeaderCell>}

                // cell={({ rowIndex, ...props }) => (<Cell style={{ whiteSpace: "nowrap" }} >{this.props.seisan_follow_list[rowIndex][value.key]}</Cell>)}
                cell={({ rowIndex, ...props }) => (
                  value.key === "transction_date" ? <TrDate column={value} props={this.props.cash_tellers_list} rowIndex={rowIndex}></TrDate>
                    : value.key === "delete" ? <Delete column={value} props={this.props} rowIndex={rowIndex}></Delete>
                      : value.key === "payment_out" ? <InOut column={value} props={this.props} rowIndex={rowIndex}></InOut>
                        : value.key === "payment_in" ? <InOut column={value} props={this.props} rowIndex={rowIndex}></InOut>
                          : value.key === "keiri" ? <Keiri column={value} props={this.props} rowIndex={rowIndex}></Keiri>
                            : value.key === "payer" ? <Payer column={value} props={this.props} rowIndex={rowIndex}></Payer>
                              : value.key === "payment_result" ? <Total column={value} props={this.props} rowIndex={rowIndex}></Total>
                                : value.key === "No" ? <No column={value} props={this.props.cash_tellers_list} rowIndex={rowIndex}></No>
                                  : <Base column={value} props={this.props.cash_tellers_list} rowIndex={rowIndex}></Base>
                )}
                width={this.state.columns.filter(a => a.key === value.key)[0].width}
                isResizable={true}
                fixed={value.frozen}
              />
            }, this)}
          </Table >
        </div>
      );
    }
  }
};


//export  default CustomerList;
const mapStateToProps = (state) => {
  return {
    cash_teller_monthly: state.CashTeller.cash_teller_monthly,
    user_details: state.masterReducer.user_details,
    cash_teller_nowmonthly: state.CashTeller.cash_teller_nowmonthly,

  }
}
function mapDispatchToProps(dispatch) {
  return {
    cash_tellers_update(state) {
      dispatch(CashTeller.cash_tellers_update(state))
    },
    cash_tellers_delete(state) {
      dispatch(CashTeller.cash_tellers_delete(state))
    },

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CashList);